export default __webpack_public_path__ + "26df16e8e63455ccc07d1a14d409c9e7.png";